import { ArrowUpRight, Cctv, LogIn, Smartphone } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const OPTIONS = [
  { label: "CCTV access", href: "https://wsafe.si", icon: Cctv, testid: "signin-cctv" },
  { label: "Mobile access", href: "https://wsafe.si", icon: Smartphone, testid: "signin-mobile" },
];

export default function SignInChooser() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="nav-signin"
        className="inline-flex items-center gap-2 whitespace-nowrap shrink-0 bg-[#09090B] hover:bg-[#FF5A00] text-white px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] border-2 border-[#09090B] transition-colors"
      >
        <LogIn strokeWidth={2.5} className="w-4 h-4" /> Sign in
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        data-testid="signin-chooser"
        className="rounded-none border-2 border-[#09090B] ws-hard-shadow-sm min-w-[220px] p-1"
      >
        <DropdownMenuLabel className="ws-label text-[#52525B]">Choose access</DropdownMenuLabel>
        {OPTIONS.map((o) => (
          <DropdownMenuItem key={o.testid} asChild className="rounded-none cursor-pointer">
            <a href={o.href} target="_blank" rel="noopener noreferrer" data-testid={o.testid}>
              <o.icon strokeWidth={2.5} className="w-4 h-4 text-[#FF5A00]" />
              <span className="font-display font-bold flex-1">{o.label}</span>
              <ArrowUpRight strokeWidth={2.5} className="w-4 h-4" />
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
